export const PRL_FLOW_TYPE = "prl";
export const PRODUCT_FLOW_TYPE = "product";
export const COMPANY_FLOW_TYPE = "merchant";
